<app-vista-seguridad>
  <section class="col-md-7 col-sm-12 p-4 rounded bg-white shadow m-auto text-center">
    <header class="mb-4">
      <h2 class="h4">Recuperar contraseña</h2>
    </header>
    <form *ngIf="isRecuerdaCorreo; else noRecuerdaCorreo" [formGroup]="formRecuperarContrasena" (ngSubmit)="openModal()">
      <div class="form-row mb-4 shadow">
        <div class="col-12 p-0">
          <input formControlName="correo_electronico" type="email" class="form-control recuperar-contra-input rounded-0"
            placeholder="Escribe tu correo electronico" />
          <div id="mensaje" *ngIf="!formRecuperarContrasena.controls.correo_electronico.valid && (formRecuperarContrasena.get('correo_electronico').dirty)">
            <p class="small text-danger mt-1 position-absolute font-weight-bold" text-right>Correo electrónico
              incorrecto</p>
          </div>
        </div>
      </div>
      <div class="form-row mb-4">
        <div class="col-12">
          <button type="submit" [disabled]="!formRecuperarContrasena.valid" class="btn text-white recuperar-contra-btn-principal w-100">Enviar</button>
        </div>
      </div>
    </form>
    <ng-template #noRecuerdaCorreo>
      <form [formGroup]="formRecordarCorreo" (ngSubmit)="openModal()">
        <div class="form-row mb-4 shadow">
          <div class="col-12 p-0">
            <input formControlName="usuario" type="text" class="form-control recuperar-contra-input rounded-0"
              placeholder="Escriba su nombre de usuario" (change)="onChangePistaCorreo()" />
          </div>
        </div>
        <label for="" class="small">Aquí tienes una pista de tu correo electrónico</label>
        <p class="small font-weight-bold">{{pistaCorreo}}</p>
        <div class="form-row mb-4 shadow">
          <!-- <div class="col-12 p-0">
            <input formControlName="correo_electronico" type="email" class="form-control recuperar-contra-input rounded-0"
              placeholder="">
          </div> -->
          <div class="col-12 p-0">
            <input formControlName="correo_electronico" type="email" class="form-control recuperar-contra-input rounded-0"
              placeholder="Escribe tu correo electronico" />
            <div id="mensaje" *ngIf="!formRecuperarContrasena.controls.correo_electronico.valid && (formRecuperarContrasena.get('correo_electronico').dirty)">
              <p class="small text-danger mt-1 position-absolute font-weight-bold" text-right>Correo electrónico
                incorrecto</p>
            </div>
          </div>
        </div>
        <div class="form-row mb-4">
          <div class="col-12">
            <button type="submit" [disabled]="!formRecordarCorreo.valid" class="btn text-white recuperar-contra-btn-principal w-100">Enviar</button>
          </div>
        </div>
      </form>
    </ng-template>
    <footer *ngIf="isRecuerdaCorreo" class="col-12 pt-4 border-top">
      <a class="text-body pointer" (click)="recordarCorreo($event)"><span>¿No recuerdas tu correo? <strong>Click aquí</strong></span></a>
    </footer>
  </section>
</app-vista-seguridad>